import getApiClient from '@/plugins/api-client'

export default {
    loadSymplaEvent: function(id) {
        const self = this,
            api = getApiClient(self.$store)

        api.get(`sympla_events/${id}/full`)
            .then(result => {
                self.symplaEvent = result.data
                self.symplaEvent.token = self.symplaEvent.token['@id']
            })
            .catch(error => {
                console.log(error)
            })
    },
    saveSymplaEvent: function() {
        const self = this,
            symplaEventId = self.symplaEvent.id

        if (symplaEventId) {
            return self.updateSymplaEvent()
        }

        return self.createSymplaEvent()
    },
    setEventToken: function(token) {
        this.symplaEvent.token = token
    },
    createSymplaEvent: function() {
        const self = this,
            api = getApiClient(self.$store)

        self.resetFormResult()

        const payload = self.symplaEvent
        if (!payload.badge.match(/data:image\/svg\+xml;base64,/g)) {
            delete payload.badge
        }

        api.post('sympla_events', payload)
            .then(result => {
                self.symplaEvent = result.data
                self.symplaEvent.token = self.symplaEvent.token['@id']
                self.success = true
            })
            .catch(error => {
                switch (error.response.status) {
                    case 424:
                        self.errors['symplaId'] = error.response.data['hydra:description']
                        break;
                    case 400:
                    case 422:
                        let violations = error.response.data.violations
                        violations.forEach((violation) => {
                            self.errors[violation.propertyPath] = violation.message
                        })
                        break;
                }
            })
    },
    updateSymplaEvent: function() {
        const self = this,
            api = getApiClient(self.$store)

        self.resetFormResult()

        const payload = self.symplaEvent
        if (!payload.badge.match(/data:image\/svg\+xml;base64,/g)) {
            delete payload.badge
        }
        api.patch(`sympla_events/${self.symplaEvent.id}`, payload, {
            headers: {
                'Content-Type': 'application/merge-patch+json'
            }
        })
            .then(result => {
                self.symplaEvent = result.data
                self.symplaEvent.token = self.symplaEvent.token['@id']
                self.success = true
            })
            .catch(error => {
                switch (error.response.status) {
                    case 424:
                        self.errors['symplaId'] = error.response.data['hydra:description']
                        break;
                    case 400:
                    case 422:
                        let violations = error.response.data.violations
                        violations.forEach((violation) => {
                            self.errors[violation.propertyPath] = violation.message
                        })
                        break;
                }
            })
    },

    loadSymplaTokens: function() {
        const self = this,
            api = getApiClient(self.$store)

        api.get('sympla_tokens')
            .then(result => {
                self.symplaTokens = result.data['hydra:member']
            })
            .catch(error => {
                console.log(error)
            })
    },

    resetFormResult: function() {
        const self = this
        Object.keys(self.errors).forEach((error) => {
            self.errors[error] = null
        })
        self.success = false
    },

    toggleEventCategory(category) {
        if (this.symplaEvent.categories.includes(category)) {
            this.symplaEvent.categories = this.symplaEvent.categories.filter(value => {
                return value !== category
            })
            return
        }
        this.symplaEvent.categories.push(category)
    },

    setBadge(files) {
        const self = this,
            image = files[0],
            reader = new FileReader()
        reader.readAsDataURL(image)
        reader.onload = e => {
            self.symplaEvent.badge = e.target.result;
        }
    },
}
